import {
  AfterViewInit,
  Component,
  ElementRef,
  input,
  OnDestroy,
  output,
  signal,
  viewChild,
} from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { distinctUntilChanged, Subject, takeUntil } from "rxjs";
import {
  PlayerWithConfirmationButton,
  registerConfirmationButtonPlugin,
} from "src/app/video-js-plugins/confirmation-button.plugin";
import videojs from "video.js";
import Player from "video.js/dist/types/player";

@Component({
  selector: "app-video-player",
  imports: [],
  templateUrl: "./video-player.component.html",
  styles: ``,
})
export class VideoPlayerComponent implements OnDestroy, AfterViewInit {
  video = input.required<{ url: string; contentType: string }>();
  canShowConfirmation = input.required<boolean>();

  private destroyRef$ = new Subject<void>();

  videoSourceChanged$ = toObservable(this.video).pipe(
    distinctUntilChanged((a, b) => a.url == b.url),
    takeUntil(this.destroyRef$),
  );

  videoElement =
    viewChild.required<ElementRef<HTMLVideoElement>>("videoElement");

  player: Player | undefined;

  endReached = signal<boolean>(false);

  confirm = output<void>();

  confirmButtonText = input("");

  ngAfterViewInit(): void {
    registerConfirmationButtonPlugin();

    this.videoSourceChanged$.subscribe(({ url, contentType }) => {
      console.log(`videoSourceChanged: ${url}, ${contentType}`);

      this.endReached.set(false);
      if (this.player) {
        this.player.src({
          src: url,
          type: contentType,
        });
      } else {
        this.player = videojs(
          this.videoElement().nativeElement,
          {
            autoplay: false,
            controls: true,
            fill: true,
            fluid: true,
            bigPlayButton: true,
            controlBar: {
              pictureInPictureToggle: false,
              playToggle: true,
              fullscreenToggle: true,
              progressControl: {
                seekBar: true,
              },
            },
            userActions: {
              doubleClick: false,
            },
            sources: [
              {
                src: url,
                type: contentType,
              },
            ],
            preload: "metadata", // XXX: maybe set to something different to be faster?
          },
          () => {},
        );
      }

      this.player.on("ended", () => {
        this.endReached.set(true);
      });

      // XXX: The Typescript Type definitions are not working properly in video.js version > 8
      (this.player as PlayerWithConfirmationButton).confirmationButton({
        buttonText: this.confirmButtonText(),
        onConfirm: () => {
          this.confirm.emit();
        },
        shouldShow: this.canShowConfirmation,
      });
    });
  }

  ngOnDestroy(): void {
    this.destroyRef$.next();
    this.destroyRef$.complete();
  }
}
